import { Point } from '../view-models/common-models';

export interface IIntersectPoint {
    x: number;
    y: number;
    isIntersection?: boolean;
}
export class Geometry {
    // Public Functions

    static intersection(a: Point, b: Point, c: Point, d: Point): IIntersectPoint {
        const det = (a.x - b.x) * (c.y - d.y) - (a.y - b.y) * (c.x - d.x);

        const l = a.x * b.y - a.y * b.x;
        const m = c.x * d.y - c.y * d.x;

        const ix = (l * (c.x - d.x) - m * (a.x - b.x)) / det;
        const iy = (l * (c.y - d.y) - m * (a.y - b.y)) / det;
        const i = this.P(ix, iy);

        i.isIntersection = !(a.x < ix !== ix < b.x) && !(c.x < ix !== ix < d.x);

        return i;
    }

    static getPosition(element: HTMLElement) {
        const elPos = element.getBoundingClientRect();
        const vpPos = this.getVpPos(element);

        return {
            top: elPos.top - (vpPos?.top ?? 0),
            left: elPos.left - (vpPos?.left ?? 0),
            width: elPos.width,
            bottom: elPos.bottom - (vpPos?.top ?? 0),
            height: elPos.height,
            right: elPos.right - (vpPos?.left ?? 0),
        };
    }

    // Private Functions

    private static P(x: number, y: number): IIntersectPoint {
        const rv = { x: x, y: y };
        rv.toString = function () {
            return rv.x + ',' + rv.y;
        };
        return rv;
    }

    private static getVpPos(el: HTMLElement): DOMRect | null {
        if (el.parentElement?.tagName === 'svg') {
            return el.parentElement.getBoundingClientRect();
        }
        if (el.parentElement) return this.getVpPos(el.parentElement);
        return null;
    }
}
